import React from 'react';
import { Presentation } from './pages/Presentation';
export function App() {
  return <div className="w-full h-screen" data-id="element-0">
      <Presentation data-id="element-1" />
    </div>;
}